<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索区域 -->
        <div class="table-page-search-wrapper" :class="{ 'is-collapsed': !advanced }">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="空间名称">
                  <a-input
                    v-model:value="queryParam.name"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="所属大楼名">
                  <a-input
                    v-model:value="queryParam.buildingName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="所属楼层">
                  <a-input
                    v-model:value="queryParam.floorName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <span class="search-actions-group">
                      <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </span>
                </a-form-item>
              </a-col>

              <template v-if="advanced">
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="服务职责">
                    <a-input
                      v-model:value="queryParam.serviceResponsibilities"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="空间性质">
                    <a-select
                      v-model:value="queryParam.spatialProperties"
                      placeholder="请选择"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dictSpatialProperties"
                        :key="d.dictValue"
                        :value="d.dictValue"
                        >{{ d.dictLabel }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="是否贴码">
                    <a-select
                      v-model:value="queryParam.isLabeling"
                      placeholder="请选择"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dictSysYesNoNumber"
                        :key="d.dictValue"
                        :value="d.dictValue"
                        >{{ d.dictLabel }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <!--                <a-col :md="6" :sm="24">-->
                <!--                  <a-form-item label="服务时长">-->
                <!--                    <a-input-number-->
                <!--                      v-model:value="queryParam.serviceDuration"-->
                <!--                      :min="0"-->
                <!--                      style="width: 100%"-->
                <!--                      placeholder="请输入"-->
                <!--                      class="no-border-radius-input-number"-->
                <!--                    />-->
                <!--                  </a-form-item>-->
                <!--                </a-col>-->
                <!--                <a-col :md="6" :sm="24">-->
                <!--                  <a-form-item label="服务频次">-->
                <!--                    <a-input-number-->
                <!--                      v-model:value="queryParam.serviceFrequency"-->
                <!--                      :min="0"-->
                <!--                      style="width: 100%"-->
                <!--                      placeholder="请输入"-->
                <!--                      class="no-border-radius-input-number"-->
                <!--                    />-->
                <!--                  </a-form-item>-->
                <!--                </a-col>-->
                <!--                <a-col :md="6" :sm="24">-->
                <!--                  <a-form-item label="单次最低时长" :colon="false">-->
                <!--                    <a-input-number-->
                <!--                      v-model:value="queryParam.minimumDuration"-->
                <!--                      :min="0"-->
                <!--                      style="width: 100%"-->
                <!--                      placeholder="请输入"-->
                <!--                      class="no-border-radius-input-number"-->
                <!--                    />-->
                <!--                  </a-form-item>-->
                <!--                </a-col>-->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="Level">
                    <a-input
                      v-model:value="queryParam.level"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="信标MAC码">
                    <a-input
                      v-model:value="queryParam.beaconMac"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!--                <a-col :md="6" :sm="24">-->
                <!--                  <a-form-item label="Corx">-->
                <!--                    <a-input-->
                <!--                      v-model:value="queryParam.corx"-->
                <!--                      placeholder="请输入"-->
                <!--                      allow-clear-->
                <!--                      class="no-border-radius-input"-->
                <!--                    />-->
                <!--                  </a-form-item>-->
                <!--                </a-col>-->
                <!--                <a-col :md="6" :sm="24">-->
                <!--                  <a-form-item label="Cory">-->
                <!--                    <a-input-->
                <!--                      v-model:value="queryParam.cory"-->
                <!--                      placeholder="请输入"-->
                <!--                      allow-clear-->
                <!--                      class="no-border-radius-input"-->
                <!--                    />-->
                <!--                  </a-form-item>-->
                <!--                </a-col>-->

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <span class="search-actions-group">
                        <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                        <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                          {{ advanced ? '收起' : '展开' }}
                          <UpOutlined v-if="advanced" />
                          <DownOutlined v-else />
                        </a-button>
                      </span>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="refreshData"
            v-hasPermi="['system:space:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" style="width: 32px; height: 32px" />
          </a-button>
          <a-button
            type="primary"
            @click="createFormRef?.handleAdd()"
            v-hasPermi="['system:space:add']"
            class="add-button"
          >
            <PlusOutlined />新增
          </a-button>
          <a-button
            @click="handleExport"
            v-hasPermi="['system:space:export']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导出
          </a-button>
          <a-button
            @click="importExcelRef?.importExcelHandleOpen()"
            v-hasPermi="['system:space:import']"
            class="no-border-button import-export-button"
          >
            <ImportOutlined />导入
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleBatchDownloadQrCode"
            v-hasPermi="['system:space:batchDownloadQRCodes']"
            class="no-border-button download-qrcode-button"
          >
            <DownloadOutlined />下载二维码
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:space:remove']"
            class="no-border-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <a-button
            @click="handleDownloadTemplate"
            v-hasPermi="['system:space:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />导入模板下载
          </a-button>
        </div>
        <!-- 组件 -->
        <import-excel ref="importExcelRef" @ok="getList" />
        <create-form ref="createFormRef" @ok="getList" @close="getList" />
        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :row-selection="rowSelection"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 2000 }"
            class="optimized-table"
          >
            <!-- 使用 bodyCell 插槽自定义单元格显示 -->
            <template #bodyCell="{ column, text, record, index }">
              <!-- 序号列：考虑分页计算序号 -->
              <template v-if="column.dataIndex === 'id'">
                <span>{{ (queryParam.pageNum - 1) * queryParam.pageSize + index + 1 }}</span>
              </template>
              <!-- 空间性质：显示文字 -->
              <template v-else-if="column.dataIndex === 'spatialProperties'">
                <span>
                  {{
                    dictSpatialProperties.find((d) => d.dictValue === record.spatialProperties)?.dictLabel ||
                    record.spatialProperties ||
                    '-'
                  }}
                </span>
              </template>
              <!-- 是否贴码：显示文字 -->
              <template v-else-if="column.dataIndex === 'isLabeling'">
                <span>
                  {{
                    dictSysYesNoNumber.find((d) => String(d.dictValue) === String(record.isLabeling))?.dictLabel ||
                    record.isLabeling ||
                    '-'
                  }}
                </span>
              </template>
              <!-- 信标MAC码：完整展示，不换行，宽度自适应 -->
              <template v-else-if="column.dataIndex === 'beaconMac'">
                <span class="beacon-mac-full-text">{{ text || '-' }}</span>
              </template>
              <!-- 操作列 -->
              <template v-else-if="column.dataIndex === 'operation'">
                <div class="table-action-buttons">
                  <a
                    @click="createFormRef?.handleUpdate(record, undefined)"
                    v-hasPermi="['system:space:edit']"
                    class="edit-link"
                  >
                    编辑
                  </a>
                  <span v-if="record.qrCode" v-hasPermi="['system:space:downloadQRCode']" class="action-divider"
                    >|</span
                  >
                  <a
                    @click="handleDownloadQrCode(record)"
                    v-if="record.qrCode"
                    v-hasPermi="['system:space:downloadQRCode']"
                    class="download-qrcode-link"
                  >
                    下载二维码
                  </a>
                </div>
              </template>
              <!-- 其他字段：默认显示 text 值 -->
              <template v-else>
                <span>{{ text }}</span>
              </template>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="() => ''"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, markRaw, nextTick } from 'vue'
import { useStore } from 'vuex'
import { message, Modal } from 'ant-design-vue'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  ImportOutlined,
  DownloadOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons-vue'
/**
 * 空间管理页面
 * 功能：提供空间的查询、新增、编辑、删除、导入导出、批量下载二维码等功能
 */
import { pageSpace, delSpace, changeSpaceStatus } from '@/api/system/space'
import { getDicts } from '@/api/system/dict/data'
import { download } from '@/utils/request'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'

const store = useStore()

// 字典数据
const dictSpatialProperties = ref([])
const dictSysYesNoNumber = ref([])

// 初始化字典
const initDicts = async () => {
  try {
    const [spatialRes, yesNoRes] = await Promise.all([
      getDicts('spatial_properties').catch(() => ({ data: [] })),
      getDicts('sys_yes_no_number').catch(() => ({ data: [] })),
    ])
    dictSpatialProperties.value = spatialRes.data || []
    dictSysYesNoNumber.value = yesNoRes.data || []
  } catch (error) {
    console.error('初始化字典失败:', error)
  }
}

// 响应式数据
const list = ref([])
const selectedRowKeys = ref([])
const selectedRows = ref([])
const advanced = ref(false)
const loading = ref(false)
const total = ref(0)
const createFormRef = ref(null)
const importExcelRef = ref(null)
const jumpPage = ref(1)

// 查询参数
const queryParam = reactive({
  projectId: null,
  name: null,
  buildingName: null,
  floorName: null,
  serviceResponsibilities: null,
  serviceDuration: null,
  serviceFrequency: null,
  minimumDuration: null,
  level: null,
  spatialProperties: undefined,
  isLabeling: undefined,
  beaconMac: null,
  corx: null,
  cory: null,
  pageNum: 1,
  pageSize: 10,
})

// 计算属性
const multiple = computed(() => selectedRowKeys.value.length === 0)
const ids = computed(() => selectedRows.value.map((item) => item.id))
const tableSize = computed(() => store.state.app.tableSize || 'default')
const tableBordered = computed(() => store.state.app.tableBordered || false)
const submitButtonStyle = computed(() => {
  return {}
})
const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: onSelectChange,
  fixed: true,
}))

// 表格列配置
const columns = markRaw([
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center',
  },
  {
    title: '空间名称',
    dataIndex: 'name',
    width: 220,
    align: 'center',
  },
  // {
  //   title: '所属大楼名',
  //   dataIndex: 'buildingName',
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   title: '所属楼层',
  //   dataIndex: 'floorName',
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   title: '服务职责',
  //   dataIndex: 'serviceResponsibilities',
  //   width: 150,
  //   align: 'center',
  // },
  {
    title: '空间性质',
    dataIndex: 'spatialProperties',
    width: 280,
    align: 'center',
  },
  {
    title: '是否贴码',
    dataIndex: 'isLabeling',
    width: 150,
    align: 'center',
  },
  {
    title: '服务时长',
    dataIndex: 'serviceDuration',
    width: 200,
    align: 'center',
  },
  {
    title: '服务频次',
    dataIndex: 'serviceFrequency',
    width: 180,
    align: 'center',
  },
  {
    title: '单次最低时长',
    dataIndex: 'minimumDuration',
    width: 130,
    align: 'center',
  },
  {
    title: 'Level',
    dataIndex: 'level',
    width: 130,
    align: 'center',
  },
  {
    title: '信标MAC码',
    dataIndex: 'beaconMac',
    align: 'center',
    width: 180, // 设置宽度，能够完整展示MAC地址内容（通常17个字符）
    ellipsis: false, // 不省略，完整展示内容
  },
  {
    title: 'Corx',
    dataIndex: 'corx',
    width: 160,
    align: 'center',
  },
  {
    title: 'Cory',
    dataIndex: 'cory',
    width: 160,
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 250,
    fixed: 'right',
    align: 'center',
  },
])

// 方法
/**
 * 查询空间列表
 * 根据查询参数分页获取空间数据
 */
const getList = async () => {
  try {
    loading.value = true
    const currentProjectId = store.getters.currentProjectId
    if (currentProjectId) {
      queryParam.projectId = currentProjectId
    }
    // 构建请求参数，过滤掉空值
    const params = { ...queryParam }
    // 移除空值参数，避免传递无效参数
    Object.keys(params).forEach((key) => {
      if (params[key] === undefined || params[key] === null || params[key] === '') {
        delete params[key]
      }
    })
    const response = await pageSpace(params)
    list.value = response.data.records || []
    total.value = response.data.total || 0
    jumpPage.value = queryParam.pageNum
  } catch (error) {
    console.error('获取空间列表失败:', error)
    list.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

/**
 * 搜索按钮操作
 * 重置到第一页并重新查询
 */
const handleQuery = () => {
  queryParam.pageNum = 1
  getList()
}

/**
 * 刷新数据
 */
const refreshData = () => {
  getList()
}

/**
 * 重置按钮操作
 * 清空所有查询条件，保留项目ID和分页参数
 */
const resetQuery = () => {
  // 从 Vuex 获取当前项目ID作为默认值
  const currentProjectId = store.getters.currentProjectId
  // 直接赋值确保响应式更新
  queryParam.name = null
  queryParam.buildingName = null
  queryParam.floorName = null
  queryParam.serviceResponsibilities = null
  queryParam.serviceDuration = null
  queryParam.serviceFrequency = null
  queryParam.minimumDuration = null
  queryParam.level = null
  queryParam.spatialProperties = undefined
  queryParam.isLabeling = undefined
  queryParam.beaconMac = null
  queryParam.corx = null
  queryParam.cory = null
  queryParam.pageNum = 1
  queryParam.pageSize = 10
  queryParam.projectId = currentProjectId || null

  // 使用 nextTick 确保响应式更新后再查询
  nextTick(() => {
    handleQuery()
  })
}

/**
 * 每页条数变化
 * @param {Number} current - 当前页码
 * @param {Number} pageSize - 每页条数
 */
const onShowSizeChange = (current, pageSize) => {
  if (loading.value) return
  queryParam.pageSize = pageSize
  queryParam.pageNum = 1
  jumpPage.value = 1
  getList()
}

/**
 * 分页变化
 * @param {Number} current - 当前页码
 * @param {Number} pageSize - 每页条数
 */
const changeSize = (current, pageSize) => {
  if (loading.value) return
  queryParam.pageNum = current
  queryParam.pageSize = pageSize
  jumpPage.value = current
  getList()
}

/**
 * 跳转到指定页面
 */
const handleJumpPage = () => {
  if (loading.value) return
  const maxPage = Math.ceil(total.value / queryParam.pageSize)
  if (jumpPage.value < 1) {
    jumpPage.value = 1
  } else if (jumpPage.value > maxPage) {
    jumpPage.value = maxPage
  }
  queryParam.pageNum = jumpPage.value
  getList()
}

/**
 * 表格行选择变化
 * @param {Array} selectedRowKeys - 选中的行key数组
 * @param {Array} selectedRows - 选中的行数据数组
 */
const onSelectChange = (keys, rows) => {
  selectedRowKeys.value = keys
  selectedRows.value = rows
}

/**
 * 切换高级搜索展开/收起
 */
const toggleAdvanced = () => {
  advanced.value = !advanced.value
}
/**
 * 启用按钮操作
 */
const handleEnable = () => {
  handleChangeStatus(1)
}

/**
 * 禁用按钮操作
 */
const handleDisable = () => {
  handleChangeStatus(0)
}

/**
 * 批量修改空间状态（启用/禁用）
 * @param {Number} status - 状态值（1-启用，0-禁用）
 */
const handleChangeStatus = (status) => {
  if (!selectedRowKeys.value.length) {
    message.warning('请先选择需要操作的数据')
    return
  }
  const actionText = status === 1 ? '启用' : '禁用'
  const ids = [...selectedRowKeys.value]
  Modal.confirm({
    title: `确认${actionText}所选中数据?`,
    content: `当前选中编号为 ${ids.join(', ')} 的数据`,
    onOk: async () => {
      try {
        const data = {
          ids: ids.join(','),
          status: status,
        }
        await changeSpaceStatus(data)
        message.success(`${actionText}成功`)
        onSelectChange([], [])
        getList()
      } catch (error) {
        console.error(`${actionText}失败:`, error)
      }
    },
  })
}
/**
 * 删除按钮操作
 * @param {Object} row - 要删除的行数据（可选，如果传入则删除单条，否则删除选中的多条）
 */
const handleDelete = (row) => {
  const deleteIds = row?.id ? [row.id] : ids.value
  // 获取要删除的空间名称
  let spaceNames = []
  if (row?.id) {
    // 单条删除
    spaceNames = [row.name || '未知空间']
  } else {
    // 多条删除
    spaceNames = selectedRows.value.map((item) => item.name || '未知空间')
  }
  Modal.confirm({
    title: '确认删除所选中数据?',
    content: `删除空间名称为 ${spaceNames.join('、')}`,
    onOk: async () => {
      try {
        // 构建删除参数
        const data = deleteIds.map((id) => ({ id }))
        await delSpace(data)
        // 清空选择并刷新列表
        onSelectChange([], [])
        getList()
        message.success('删除成功')
      } catch (error) {
        console.error('删除失败:', error)
      }
    },
  })
}

/**
 * 下载导入模板
 */
const handleDownloadTemplate = () => {
  download('system/space/importTemplate', {}, `空间导入模板_${new Date().getTime()}.xls`)
}

/**
 * 导出按钮操作
 * 支持导出选中数据或当前筛选条件下的全部数据
 */
const handleExport = () => {
  const params = { ...queryParam }
  const hasSelection = selectedRowKeys.value && selectedRowKeys.value.length > 0
  if (hasSelection) {
    params.spaceIds = selectedRowKeys.value
  }
  Modal.confirm({
    title: '是否确认导出?',
    content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
    onOk: () => {
      download('system/space/export', params, `空间_${new Date().getTime()}.xls`)
    },
  })
}
/**
 * 处理项目变化事件
 * 当右侧项目选择发生变化时，更新查询参数并刷新列表
 * @param {Number} projectId - 新选中的项目ID
 */
const handleProjectChanged = (projectId) => {
  // 更新查询参数中的项目ID
  queryParam.projectId = projectId
  // 重置到第一页并刷新列表
  queryParam.pageNum = 1
  getList()
}

/**
 * 下载单个空间二维码
 * @param {Object} record - 空间记录对象
 */
const handleDownloadQrCode = (record) => {
  if (!record.qrCode) {
    message.warning('该空间没有二维码')
    return
  }
  const imageUrl = record.qrCode
  const fileName = `${record.name || '空间二维码'}.png`

  // 使用 fetch 获取图片，支持跨域
  fetch(imageUrl)
    .then((response) => response.blob())
    .then((blob) => {
      // 创建 Blob URL
      const blobUrl = window.URL.createObjectURL(blob)
      // 创建临时链接
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName
      // 添加到DOM并触发点击
      document.body.appendChild(link)
      link.click()
      // 清理
      document.body.removeChild(link)
      // 释放 Blob URL
      window.URL.revokeObjectURL(blobUrl)
      message.success('二维码下载成功')
    })
    .catch((error) => {
      console.error('下载二维码失败:', error)
      // 如果 fetch 失败，尝试直接下载
      try {
        const link = document.createElement('a')
        link.href = imageUrl
        link.download = fileName
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        message.success('二维码下载成功')
      } catch (e) {
        message.error('下载二维码失败，请稍后重试')
      }
    })
}
/**
 * 批量下载二维码
 * 验证选中的数据是否满足条件（必须「是否贴码」为"是"且有二维码），然后打包为 zip 下载
 */
const handleBatchDownloadQrCode = () => {
  if (!selectedRows.value || selectedRows.value.length === 0) {
    message.warning('请先选择需要下载二维码的数据')
    return
  }

  // 过滤出有二维码的记录
  const recordsWithQrCode = selectedRows.value.filter((record) => record.qrCode)
  // 过滤出「是否贴码」不为"是"的记录
  const invalidRecords = selectedRows.value.filter((record) => Number(record.isLabeling) !== 1)

  // 验证：必须「是否贴码」为"是"
  if (invalidRecords.length > 0) {
    message.warning('请选择「是否贴码」为"是"的空间')
    return
  }

  // 验证：必须有二维码
  if (recordsWithQrCode.length === 0) {
    message.warning('所选数据中没有包含二维码的空间')
    return
  }

  // 确认对话框
  Modal.confirm({
    title: '确认批量下载二维码?',
    content: `当前选中 ${recordsWithQrCode.length} 个包含二维码的空间，将打包为压缩包下载`,
    onOk: () => downloadQrCodesAsZip(recordsWithQrCode),
  })
}

/**
 * 获取二维码图片在压缩包内的文件名（使用空间名称，重名时追加序号）
 * @param {String} name - 空间名称
 * @param {Set} usedNames - 已使用的文件名集合
 */
const getQrCodeFileName = (name, usedNames) => {
  const safeName = (name || '空间二维码').replace(/[\\/:*?"<>|]/g, '_')
  let fileName = `${safeName}.png`
  if (!usedNames.has(fileName)) {
    usedNames.add(fileName)
    return fileName
  }
  let index = 2
  while (usedNames.has(`${safeName}(${index}).png`)) {
    index++
  }
  fileName = `${safeName}(${index}).png`
  usedNames.add(fileName)
  return fileName
}

/**
 * 批量下载二维码并打包为 zip
 * zip 文件名为当前时间戳，解压后内含同名文件夹，文件夹中为各空间二维码图片
 * @param {Array} records - 要下载的空间记录数组
 */
const downloadQrCodesAsZip = async (records) => {
  const timestamp = Date.now()
  const folderName = String(timestamp)
  const zip = new JSZip()
  const folder = zip.folder(folderName)
  const usedNames = new Set()
  let successCount = 0
  let failCount = 0

  const hideLoading = message.loading('正在打包二维码，请稍候...', 0)

  await Promise.all(
    records.map(async (record) => {
      try {
        const response = await fetch(record.qrCode)
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`)
        }
        const blob = await response.blob()
        const fileName = getQrCodeFileName(record.name, usedNames)
        folder.file(fileName, blob)
        successCount++
      } catch (error) {
        console.error(`下载二维码失败 [${record.name}]:`, error)
        failCount++
      }
    })
  )

  hideLoading()

  if (successCount === 0) {
    message.error('所有二维码下载失败，请稍后重试')
    return
  }

  const zipBlob = await zip.generateAsync({ type: 'blob' })
  saveAs(zipBlob, `${folderName}.zip`)

  const msg =
    failCount === 0
      ? `批量下载完成，共 ${successCount} 个二维码`
      : `批量下载完成：成功 ${successCount} 个，失败 ${failCount} 个`
  if (failCount === 0) {
    message.success(msg)
  } else {
    message.warning(msg)
  }
}

// 生命周期
onMounted(() => {
  // 初始化字典
  initDicts()
  // 初始化时从 Vuex 获取项目ID
  const currentProjectId = store.getters.currentProjectId
  if (currentProjectId) {
    queryParam.projectId = currentProjectId
  }
  // 获取空间列表
  getList()
})

// 监听 Vuex 项目变化，切换顶部项目后自动刷新列表
watch(
  () => store.getters.currentProjectId,
  (projectId, prevProjectId) => {
    if (projectId !== prevProjectId) {
      handleProjectChanged(projectId)
    }
  }
)
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px !important;
  max-width: 80px !important;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
}

.table-page-search-wrapper :deep(.ant-form-item) {
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-row) {
  flex-wrap: nowrap;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 0 !important;
  max-width: none !important;
  margin-left: 8px;
  min-width: 0;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content) {
  width: 100%;
  min-width: 0;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper.is-collapsed :deep(.ant-form-item-control-input .ant-input) {
  max-width: none !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper.is-collapsed :deep(.ant-input-affix-wrapper) {
  max-width: none !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: 0;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper.is-collapsed :deep(.ant-picker) {
  max-width: none !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper.is-collapsed :deep(.ant-select-selector) {
  max-width: none !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 搜索区域数字输入框样式 - 服务时长、服务频次、单次最低时长 */
.table-page-search-wrapper :deep(.no-border-radius-input-number.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 数字输入框聚焦样式 - 保持边框，不高亮 */
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number:focus),
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number-focused),
.table-page-search-wrapper :deep(.ant-input-number:focus),
.table-page-search-wrapper :deep(.ant-input-number-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 数字输入框内部input聚焦样式 - 隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number:focus .ant-input-number-input),
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number-focused .ant-input-number-input),
.table-page-search-wrapper :deep(.ant-input-number:focus .ant-input-number-input),
.table-page-search-wrapper :deep(.ant-input-number-focused .ant-input-number-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.search-actions-col {
  display: flex;
  justify-content: flex-end;
}

.search-actions-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap;
  /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

@media (max-width: 992px) {
  .table-page-search-wrapper :deep(.ant-form-item-row) {
    flex-wrap: wrap;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label) {
    width: auto;
    min-width: 0;
    flex: 0 0 auto !important;
    max-width: none !important;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label > label) {
    width: auto;
    text-align: left;
  }

  .table-page-search-wrapper :deep(.ant-form-item-control) {
    flex: 1 1 100% !important;
    max-width: none !important;
    margin-left: 0;
  }

  .search-actions-col {
    justify-content: flex-start;
  }
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 下载二维码按钮样式 */
.download-qrcode-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.download-qrcode-button:hover,
.download-qrcode-button:focus {
  color: #333333 !important;
}

.download-qrcode-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 表格操作列中下载二维码链接样式 */
.table-action-buttons .download-qrcode-link {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.table-action-buttons .download-qrcode-link:hover {
  color: #333333 !important;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover:not(:disabled),
.no-border-button:focus:not(:disabled) {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

/* 禁用状态样式 */
.no-border-button:disabled,
.no-border-button[disabled] {
  border: none !important;
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.no-border-button:disabled:hover,
.no-border-button:disabled:focus,
.no-border-button[disabled]:hover,
.no-border-button[disabled]:focus {
  border: none !important;
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 导入导出按钮背景颜色 */
.import-export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button :deep(.anticon) {
  color: #333 !important;
}

.import-export-button:hover,
.import-export-button:focus {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button:hover :deep(.anticon),
.import-export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.template-download-button {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.template-download-button:hover,
.template-download-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap;
  /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px;
  /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 信标MAC码列：完整展示内容，不换行，宽度自适应 */
.optimized-table :deep(.ant-table-tbody > tr > td) .beacon-mac-full-text {
  white-space: nowrap !important;
  display: inline-block;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 选中行的操作列样式 */
.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}
</style>
